module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/1@2x_eb3b71b61ffefd8fc28a0e12ee031d0e.png";